export default [
  {
    path: '/fss',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/fssAdmin.vue'),
    children: [
      {
        path: '',
        name: 'fss',
        component: () => import('~/fss/pages/Index.vue'),
      },
      {
        path: '/fss/companies',
        name: 'fssCompanies',
        component: () => import('~/fss/companies/pages/Index.vue'),
      },
      {
        path: '/fss/company/account/:id',
        name: 'fssCompanyAccount',
        component: () => import('~/companies/pages/Account.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
      {
        path: '/fss/ticket-types',
        name: 'fssTicketTypes',
        component: () => import('~/ticketWallet/pages/TicketTypes.vue'),
      },
    ],
  },
];
